import { emitCloseEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'collapsed'
  };
};

const track = (widgetTracking, featureIndex) => {
  const widgetEvent = buildWidgetTrackingData(widgetTracking, featureIndex);
  const features = [widgetEvent];
  const event = {
    name: 'close',
    features: features
  };
  emitCloseEvent(event, {});
};

export default track;
